import { ReactNode } from "react";

export type HeadingElements = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export type HeadingProps = {
  Element?: HeadingElements;
  children?: ReactNode;
  className?: string;
  sourceId?: string;
};
export default function Heading({
  Element = "h1",
  children,
  className,
  sourceId,
}: HeadingProps) {
  return (
    <Element
      className={className}
      {...(sourceId && { "data-beyondwords-marker": sourceId })}
    >
      {children}
    </Element>
  );
}
